
  import { defineComponent, computed } from 'vue';
  import { InspectionActivity } from '@/entities/activity/model';
  import { CreatedAt } from '@/ui/components/activityLogs/common/CreatedAt';
  import { t } from '@/ui/i18n/i18n';
  import { boldifyStringArray } from '@/ui/components/activityLogs/helpers';

  interface ApprovalDeletedProps {
    resourceName: string;
    log: InspectionActivity;
  }

  export default defineComponent<ApprovalDeletedProps>({
    name: 'ApprovalDeleted',
    components: {
      CreatedAt,
    },
    props: ['resourceName', 'log'],
    setup(props) {
      const activityMessage = computed(() => {
        return t('activity-logs.approval-deleted', {
          username: boldifyStringArray([props.log.user?.name ?? '']),
        });
      });

      return {
        activityMessage,
      };
    },
  });
